import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { getAllTeamAction } from '../../Redux/Actions/TeamAction';
import './ACoreTeam.css'

const ACoreTeam = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const teamList = useSelector((e) => e?.TeamReducer?.teamList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        // [
        //     {
        //         "id": 12,
        //         "name": "Team Members"
        //     },
        //     {
        //         "id": 11,
        //         "name": "Core Team"
        //     }
        // ]
        dispatch(getAllTeamAction(11))
    }

    const Card = ({ item }) => (
        <div className="col-md-6 col-lg-4 mb-4" key={item?.id}>
            <div className="card h-100">
                <div className="card-body">
                    <img
                        src={`https://api.coeupdspadelhi.in/uploads/${item?.image}`}
                        className={`card-img-top ${item?.details === 'Team Leader' ? 'director-img' : 'teamMember-img'}`}
                        alt={item?.name}
                    />
                    <h6 className="fw-bold">{item?.details}</h6>
                    <p className="fw-bold mb-1 ">{item?.name}</p>
                    <h6 className="">{item?.designation}</h6>
                    <h6 className="">{item?.degree}</h6>
                </div>
            </div>
        </div>
    );

    return (
        <section>

            {
                isLoading ?
                    <div className='text-center'>
                        <Spinner animation="border" />
                    </div>
                    :
                    <>
                        <div className="row mb-4">
                            <Card item={teamList[0]} />
                        </div>
                        <div className="row mb-4">
                            <Card item={teamList[1]} />
                            <Card item={teamList[2]} />
                        </div>
                        <div className="row mb-4">
                            {teamList.slice(3).map((item) => (
                                <Card key={item.id} item={item} />
                            ))}
                        </div>
                    </>
            }

        </section>
    );
};

export default ACoreTeam;